import styled from 'styled-components';

import { Link } from 'react-router-dom';
import media from 'styled-media-query';

export const BreadcrumbGroup = styled.div`
	margin: 1.5rem 0;

    ${media.greaterThan('medium')`
        margin: 2rem 0 2.5rem;
    `}
`;

export const BreadcrumbItem = styled(Link)`
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 20px;
    position: relative;
	text-decoration: underline;
    white-space: nowrap;

    &:after {
        background: url('${process.env.PUBLIC_URL}/images/icons/arrow-right.svg') no-repeat center;
        content: '';
        height: 20px;
        position: absolute;
        width: 20px;
    }
`;

export const BreadcrumbCurrentItem = styled.span``;